module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-container"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "pull-left full-height visible-sm visible-xs"
  }, [_c('div', {
    staticClass: "sm-action-bar"
  }, [_c('a', {
    attrs: {
      "href": "",
      "data-toggle": "sidebar"
    }
  }, [_c('i', {
    staticClass: "fa",
    class: _vm.isOpen ? "fa-chevron-left" : "fa-chevron-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]), _c('div', {
    staticClass: "aplicacao-nome-topo"
  }, [_c('router-link', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "to": _vm.home
    },
    nativeOn: {
      "click": function($event) {
        return _vm.clearSelectedMenuItem.apply(null, arguments)
      }
    }
  }, [_c('span', [_vm._v("banking")])])], 1), _c('div', {
    staticClass: "pull-right"
  }, [_c('div', {
    staticClass: "visible-lg visible-md m-t-10"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_c('div', {
    staticClass: "user-info pull-right"
  }, [_c('span', {
    staticClass: "user-info-username"
  }, [_vm._v(_vm._s(_vm.username))]), _c('hr', {
    staticClass: "separador-informacoes"
  }), _c('span', {
    staticClass: "user-info-client"
  }, [_vm._v(_vm._s(_vm.clientActive))])])]), _c('div', {
    staticClass: "inline"
  }, [_c('div', {
    staticClass: "top-user-icons inline pull-right"
  }, [_c('suspended-menu')], 1)])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-54cd97fd", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54cd97fd"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/layout/menu/topBar.pug
// module id = 1414
// module chunks = 0